// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Dylwb {
  padding: 1rem; }
  .styles_container__Dylwb input {
    background-color: white;
    border-radius: 1rem; }
  .styles_container__Dylwb button {
    background-color: white; }

.styles_actions__1y3g3 {
  display: flex;
  gap: 1rem;
  margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/mapal/submodules/features/components/FeatureCommentInput/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa,EAAA;EADjB;IAGQ,uBAAuB;IACvB,mBAAmB,EAAA;EAJ3B;IAOQ,uBAAuB,EAAA;;AAI/B;EACI,aAAa;EACb,SAAS;EACT,gBAAgB,EAAA","sourcesContent":[".container {\n    padding: 1rem;\n    input { \n        background-color: white;\n        border-radius: 1rem;\n    }\n    button {\n        background-color: white;\n    }\n}\n\n.actions {\n    display: flex;\n    gap: 1rem;\n    margin-top: 1rem;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__Dylwb`,
	"actions": `styles_actions__1y3g3`
};
export default ___CSS_LOADER_EXPORT___;
